module.exports = __webpack_public_path__ + "media/application/images/insta-bg-402c747409cdfcbe7b6c69132b688a34.gif";